import { cn } from "@/utils/cn";

export default function InfoLayer({ label, info, className }) {
  const formatInfo = (value) => {
    if (value === null || value === undefined || value === '') {
      return "-";
    }
    if (Array.isArray(value)) {
      return value.length > 0 ? value.join(", ") : "-";
    }
    return value;
  };

  // Check if this is an email with verified status
  const isVerifiedEmail = typeof info === 'string' && info.includes('(verified)');

  let displayContent;
  if (isVerifiedEmail) {
    const emailParts = info.split('(verified)');
    displayContent = (
      <>
        {emailParts[0].trim()} <span className="text-green-500 font-medium">(verified)</span>
      </>
    );
  } else {
    displayContent = formatInfo(info);
  }

  return (
    <div className={cn("w-full", className)}>
      {/* Label */}
      <label className="block text-gray-700 text-sm font-medium mb-1">
        {label}
      </label>

      {/* Value Box */}
      <div className="bg-gray-100 rounded-md px-4 py-3 text-gray-600 text-sm">
        {displayContent}
      </div>
    </div>
  );
}